import { GRAPHQL_WORKSPACE, GRAPHQL_WORKSPACE_MUTATIONS } from 'graphql/workspace'
import type {
  TWorkspaceMutationData,
  TWorkspaceMutationVariables,
  TWorkspaceMutationsName,
  TWorkspaceQueriesData,
  TWorkspaceQueriesName,
  TWorkspaceQueriesVariables,
} from 'graphql/workspace/types'
import { buildLazyQueryHook, buildMutationHook, buildQueryHook } from 'lib/apollo-client/builders'

export const useWorkspaceQueries = buildQueryHook<
  TWorkspaceQueriesName,
  TWorkspaceQueriesVariables,
  TWorkspaceQueriesData
>(GRAPHQL_WORKSPACE)

export const useWorkspaceLazyQueries = buildLazyQueryHook<
  TWorkspaceQueriesName,
  TWorkspaceQueriesVariables,
  TWorkspaceQueriesData
>(GRAPHQL_WORKSPACE)

export const useWorkspaceMutations = buildMutationHook<
  TWorkspaceMutationsName,
  TWorkspaceMutationVariables,
  TWorkspaceMutationData
>(GRAPHQL_WORKSPACE_MUTATIONS)
